import { ReactElement } from 'react';

import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
import { BeneficiaryForm } from '../ServidorGDF/steps/DependentsForm';
import { AceiteForm } from './steps/AceiteForm';
import { ConfirmForm } from './steps/ConfirmForm';
import { useRouteLoaderData } from 'react-router-dom';
import { ServidorValidationForm } from '../ServidorGDF/steps/ServidorValidationForm';

export function HirePlanFormStepHandler(): ReactElement {
  const step = useHirePlanFormStepStore(state => state.step);

  switch (step) {
    case 1: {
      return <ServidorValidationForm />;
    }

    case 2: {
      return <BeneficiaryForm />;
    }

    case 3: {
      return <AceiteForm />;
    }

    case 4: {
      return <ConfirmForm />;
    }

    default: {
      return <ServidorValidationForm />;
    }
  }
  /*   } else {
    switch (step) {
      case 1: {
        return <BeneficiaryRegisterForm />;
      }

      case 2: {
        return <DependentsForm />;
      }

      case 3: {
        return <PaymentMethodForm />;
      }

      default: {
        return <BeneficiaryRegisterForm />;
      }
    }
  } */
}
